<template>
  <div v-if="breadcrumbs?.length" class="mb-24 sm:mb-32">
    <div class="truncate overflow-hidden flex items-center relative">
      <div
        v-for="(item, index) in breadcrumbs"
        :key="index"
        class="breadcrumb text-xsmall sm:text-small-regular flex-shrink-0"
      >
        <GlobalsLinkHelper
          v-if="item.linkUrl"
          :to="item.linkUrl"
        >
          <div class="inline-block align-middle underline animate-all hover:text-black hover:no-underline">
            <span>{{ item.linkText }}</span>
          </div>
          <div class="mx-8 inline-block align-middle">
            <ArrowLongRightIcon
              class="w-16 h-16"
            />
          </div>
        </GlobalsLinkHelper>
        <div v-else class="animate-all mt-2 font-medium">
          {{ item.linkText }}
        </div>
      </div>
      <div
        class="absolute right-0 top-0 h-40 w-64 -mt-6 bg-gradient-to-l -mr-24"
        :class="{
          'via-white from-white': !bgColor || layout !== 'FullColorLayout'
        }"
        :style="{
          backgroundImage: bgColor && layout === 'FullColorLayout' ? `linear-gradient(to left, ${bgColor}, ${bgColor})` : ''
        }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ArrowLongRightIcon from '@heroicons/vue/24/outline/esm/ArrowLongRightIcon';
import { useGlobalContentStore } from '~/store/globalContent';
import type { ISimpleLinkItem } from '~/api-types';

const globalContentStore = useGlobalContentStore();
const host = globalContentStore.host;

const props = defineProps<{
  breadcrumbs?: ISimpleLinkItem[],
  bgColor?: string,
  layout?: string
}>();

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: props.breadcrumbs?.map((item, index) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': host + item.linkUrl,
        name: item.linkText,
      },
    };
  }),
};

useJsonld(jsonLd);

/* 
useHead({
  script: [
    {
      type: 'application/ld-json',
      children: JSON.stringify(jsonLd),
    },
  ],
}); */

</script>
